import { render, staticRenderFns } from "./garage-material.vue?vue&type=template&id=38cfaf44&scoped=true&"
import script from "./garage-material.vue?vue&type=script&lang=js&"
export * from "./garage-material.vue?vue&type=script&lang=js&"
import style0 from "./garage-material.vue?vue&type=style&index=0&id=38cfaf44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cfaf44",
  null
  
)

export default component.exports